module.exports = __webpack_public_path__ + "img/img_08@2x.7d58c90f.png";